import { render, staticRenderFns } from "./HeroDetail.vue?vue&type=template&id=17a18090"
import script from "./HeroDetail.vue?vue&type=script&lang=js"
export * from "./HeroDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Picture: require('/srv/app/components/picture/Picture.vue').default,Markdown: require('/srv/app/components/markdown/Markdown.vue').default,Button: require('/srv/app/components/button/Button.vue').default,ButtonContactUs: require('/srv/app/components/button/ButtonContactUs.vue').default})
